exports.init = function () {
    var $submitButton = $('#eligibility-submit-button');
    var $checkboxes = $('.returns-eligibility-item:not(.disabled) input[type="checkbox"]');
    var $hiddenField = $('.js-input-selectedProducts');

    function initialize() {
        $hiddenField.val('');
        $checkboxes.prop('checked', false);
        $submitButton.prop('disabled', true);
        updateAriaChecked();
    }

    function updateAriaChecked() {
        $checkboxes.each(function () {
            var $checkbox = $(this);
            var $parent = $checkbox.closest('.returns-eligibility-item-select');
            $parent.attr('aria-checked', $checkbox.is(':checked') ? 'true' : 'false');
        });
    }

    function updateForm() {
        var selectedIds = [];

        $checkboxes.filter(':checked').each(function() {
            selectedIds.push($(this).val());
        });

        $hiddenField.val(selectedIds.join(','));
        $submitButton.prop('disabled', selectedIds.length === 0);
        updateAriaChecked();
    }

    $checkboxes.on('change', updateForm);

    initialize();
};
